import React, { useState } from "react";
import axios from "axios";
import "./Dictionary.css";
import Results from "./Results";
import Photos from "./Photos.js"

export default function Dictionary(props) {
    let [keyword, setKeyword] = useState(props.defaultKeyword);
    let [results, setResults] = useState(null);
    let [loaded, setLoaded] = useState(false);
    let [photos, setPhotos] = useState(null)

    function handleResponse(response) {
      console.log(response.data[0])
      setResults(response.data[0]);
    }
    function handlePexelsResponse(response) {
        setPhotos(response.data.photos)
    }
    function handleSubmit(event) {
      event.preventDefault();
      search();
    }
    function search(){
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en/${keyword}`;
        axios.get(apiUrl).then(handleResponse);
        const pexelsApi =
          "563492ad6f917000010000014994f2463fce4ccea6f63c10354835f9";
         let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=10`;
         axios
           .get(pexelsApiUrl, {
             headers: { Authorization: `Bearer ${pexelsApi}`},
           })
           .then(handlePexelsResponse);
    }
    function handleKeywordChange(event) {
        setKeyword(event.target.value)
    }
    function load() {
        setLoaded(true)
        search()
    }
    if  (loaded) {
    return (
      <div className="dictionary">
        <section>
            <p>What word do you want to look up?</p>
          <form onSubmit={handleSubmit}>
            <input type="search" onChange={handleKeywordChange} defaultValue={props.defaultKeyword}/>
          </form>
        </section>
        <Results results={results} />
        <Photos photos={photos} />
      </div>
    );
    } else {
        load();
        return "Loading..."
    }
}